import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Grid, ThemeProvider, makeStyles } from "@material-ui/core";
import theme from "../Login/LoginSreen.breakpoints";
import { qrCodes, users } from "../../utils/newApi";
import QRInfoBox from "../../components/QR/QRInfoBox";
import ErrorSnackBar from "../../components/Snackbar/ErrorSnackBar";
import styles from "./QRInfoScreen.styles";
import CircularProgress from "@material-ui/core/CircularProgress";

import { SERVER_ERROR_MESSAGES } from "../../constants/dictionary";

const useStyles = makeStyles(styles);

const QRInfoScreen = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [code, setCode] = useState({});
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  const handleError = (text) => {
    setError(true);
    setErrorText(text);
  };

  useEffect(() => {
    qrCodes
      .one(id)
      .then((res) => {
        setCode(res.data);
        setIsLoaded(true);
      })
      .catch((err) => {
        handleError(SERVER_ERROR_MESSAGES.COULD_NOT_FIND_QR_CODE);
      });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      {isLoaded ? (
        <Grid
          container
          justifyContent="center"
          direction="row"
          alignItems="center"
        >
          <Grid item xs={12}>
            <QRInfoBox info={code} handleError={handleError} />
          </Grid>
        </Grid>
      ) : (
        <div className={classes.container}>
          <CircularProgress color="secondary" className={classes.loader} />
        </div>
      )}

      <ErrorSnackBar
        open={error}
        text={errorText}
        close={() => setError(false)}
      />
    </ThemeProvider>
  );
};

export default QRInfoScreen;
